export default function getParams(url: string) {
  const query = url.split("?")[1]
  const vars = query.split("&")
  let id = ""
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=")
    if (pair[0] == "moment") {
      id = pair[1]
    }
  }
  return id
}
